import { TILE_SIZE } from '../constants.js';
/** Top-left pixel of a tile. Always integers, so sprites land on whole pixels. */
export function tileToPixel(tile) {
    return { px: tile.x * TILE_SIZE, py: tile.y * TILE_SIZE };
}
/** Tile containing a pixel. Negative pixels map to negative tiles (floor, not trunc). */
export function pixelToTile(pixel) {
    return { x: Math.floor(pixel.px / TILE_SIZE), y: Math.floor(pixel.py / TILE_SIZE) };
}
/** Manhattan distance in tiles — movement and melee range are 4-directional. */
export function tileDistance(a, b) {
    return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
}
/**
 * Rings around a tile: the eight neighbours are all at 1. Reach, not travel —
 * a blow lands on a diagonal even though nobody walks one.
 */
export function ringDistance(a, b) {
    return Math.max(Math.abs(a.x - b.x), Math.abs(a.y - b.y));
}
//# sourceMappingURL=grid.js.map